<p>
  This membership was paid for but never activated, because no payment method
  was saved for its future payments. Cancelling it will end the purchase.
</p>

<div class="form-group">
  <label>Where should the payment go?</label>

  <div class="form-check">
    <input class="form-check-input" type="radio" id="refundToSource"
           [value]="true" [(ngModel)]="refundToSource" name="refundDestination">
    <label class="form-check-label" for="refundToSource">
      Return it to where it came from
      <small class="form-text text-muted">
        Account credit goes back onto the customer's balance; a gift card is
        refunded to the card.
      </small>
    </label>
  </div>

  <div class="form-check mt-2">
    <input class="form-check-input" type="radio" id="refundAsCredit"
           [value]="false" [(ngModel)]="refundToSource" name="refundDestination">
    <label class="form-check-label" for="refundAsCredit">
      Issue it as account credit
      <small class="form-text text-muted">
        Safer where a gift card was used, since a gift-card refund can fail
        silently at the payment processor.
      </small>
    </label>
  </div>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
